/* eslint-disable react-hooks/exhaustive-deps */
import { AutoComplete as Auto, AutoComplete  } from "primereact/autocomplete";
import React, { useEffect, useRef, useState } from "react";
import { KeyValue } from "src/models/Core/key-value";
import * as app from "../services/AppService";
import "./Autocomplete.css";
import { AutocompleteProps } from "../models/autocomplete-props";


export default function Autocomplete(props: AutocompleteProps) {

    const [options, setOptions] = useState<KeyValue[]>([]);

    let initValue = {
        Key: "0",
        Value: props.defaultValue || ""
    };


    const [value, setValue] = useState<any>(initValue);
    const optionsFilter = props.filter || ((r: KeyValue, text: string) => (r.Value || '').toLowerCase().includes((text || '').toLowerCase()))

    const ref = useRef<AutoComplete>(null);

    useEffect(() => {
        var item = !value || typeof (value) !== "object" ? { Key: "0", Value: props.defaultValue||"" } : value;
        let selectedItem = props.options && !(String(item.Key) === "0" && props.onEnterClicked) ?
            props.options.find((i: KeyValue) => String(i.Key) === String(item.Key)) : undefined;

        if (selectedItem)
            setValue(selectedItem);
        setOptions((+(props.min || 0) > 0 && item.Value.length < +(props.min || 0)) || !props.options ? []
            : props.options);//.filter((i: KeyValue) => optionsFilter(i, !value?"": value.Value || ""))
    }, [props.options]);

    useEffect(() => {
        setValue((old:any) => ({ ...old, Value: props.defaultValue || "" }));
    }, [props.defaultValue]);

    useEffect(() => {
        let selectedItem = undefined;
        try {
            selectedItem = props.options.find((item: KeyValue) => String(item.Key) === String(props.model));
        } catch (e) { }
        if (selectedItem !== undefined) {
            selectedItemChanged(selectedItem)
        }
        else {
            selectedItemChanged({ Key: (props.model===""?"":(props.model || "0").toString()), Value: props.defaultValue || "" })
        }
    }, [props.model]);

    useEffect(() => {
        if ((value && (+props.model === 0 || String(value.Key) !== String(props.model)) && document.activeElement?.id === (props.id ? props.id : "auto" + props.label) && props.onEnterClicked !== undefined) || props.onSearch !== undefined)
            toggleDropdown(true);
    }, [options]);

    function selectedItemChanged(item: KeyValue) {
        toggleDropdown(false);
        setValue(item)
        if (props.onChange && typeof (props.onChange) == "function")
            props.onChange(item.Key, item, props.elmKey, props.options);
    }

    function onInputFocus(event: any) {
        setFocus(true)
        toggleDropdown(true);
        if (props.onFocus && typeof props.onFocus == "function") props.onFocus();
    }

    function hanldeKeydown(evt: any) {
        if (evt.charCode === 13) {
            evt.preventDefault();
            setValue(initValue)
            if (props.onEnterClicked && typeof props.onEnterClicked == "function") { 
                if (typeof value === "string") {
                    props.onEnterClicked(value);
                } else if (typeof value === "object") {
                    props.onEnterClicked(value.Value);
                }
            }
        } else {
        }
    }

    function toggleDropdown(show: boolean) {
        if (ref.current) {
            if (options?.length && show) {
                ref.current.show();
            } else if (options?.length)
                ref.current.hide();
        }
    }

    function search(Value: any) {
        if (typeof (Value) === "object") return;
        let text = Value !== undefined ? Value : props.defaultValue;
        let item: KeyValue = { Value: text, Key: '0' };

        setValue(item); 
        toggleDropdown(true);
        var options = +(props.min || 0) > 0 && Value.length < +(props.min || 0) ? [] : [
            ...props.options.filter((i: KeyValue) => optionsFilter(i, Value || "")),
        ];
        setOptions(options);
        if (props.onSearch && typeof (props.onSearch) == "function")
            props.onSearch(text);
        else if (options.length === 1 && options[0].Value === Value)
            selectedItemChanged(options[0])
    }

    function ItemTemplate(item: KeyValue) {
        return (
            <div className={"flex align-items-center" + (+item.Key === 0 && props.showNewWord ? " bold" : "")}            >
                <div>
                    {" "}{+item.Key === 0 && props.showNewWord ? `( ${item.Value} )${app.translate("new")}` : item.Value}{" "}
                </div>
            </div>
        );
    }

    const [focus, setFocus] = useState<boolean | undefined>(undefined);
    const [timer, setTimer] = useState<NodeJS.Timeout>();

    useEffect(() => {
        clearTimeout(timer);
        setTimer(setTimeout(() => {
            if (focus === false)
                setValue((old:any) => {
                    var item = old && typeof (old) === "object" ? old : { Key: "0", Value: (old && typeof (old) === "string") ? old : (props.defaultValue || "") }
                    if (props.onBlur && document.activeElement?.id !== (props.id ? props.id : "auto" + props.label)) {
                        props.onBlur?.(item);
                    }
                    var selected = props.options.find((i: KeyValue) => String(i.Key) === String(item.Key))
                    if (!selected && props.onBlur === undefined && props.onFocus === undefined && props.onEnterClicked === undefined) {
                        selectedItemChanged({ Key: "", Value: "" })
                        return "";
                    }
                    return old;
                })
        }, 300))
    }, [focus]);

    return (
        <div className={`auto-control  mt-1 ${props.containerClass || "mt-1"}`}>
            {props.label && !props.isTable && (
                <div className="d-flex justify-content-between ">
                    <label
                        className={`fw-semibold ${props.labelClass || "text-primary-emphasis"
                            }`}
                    >
                        {app.translate(props.label)}
                    </label>
                    {props.labelElm !== undefined && (
                        <label className="fw-semibold text-danger me-2">
                            {props.labelElm}
                        </label>
                    )}
                </div>
            )}

            <div className=" ctr border rounded bg-light-subtle">
                <div className=" w-100 input-group d-flex  flex-nowrap">
                    <Auto
                        ref={ref} 
                        field="Value"
                        delay={0}
                        minLength={+(props.min || 0)}
                        key={props.elmKey}
                        inputId={props.id ? props.id : "auto" + props.label}
                        disabled={props.disabled}
                        onKeyPress={hanldeKeydown}
                        onSelect={e => selectedItemChanged(e.value)}
                        onFocus={onInputFocus}
                        completeMethod={(e) => search(e.query)}
                        onClick={() => {
                            toggleDropdown(true);
                            setOptions(!value || !props.options ||(+(props.min || 0) > 0 && value.Value.length < +(props.min || 0)) ? []
                                : props.options);
                        }}
                        value={value}
                        suggestions={options}
                        onChange={(e) => {
                            setValue(e.value)
                            e.originalEvent?.preventDefault();
                        }}
                        onBlur={() => {
                            setFocus(false)
                        }}
                        className={`  border-0 rounded ${props.required
                            ? " is-invalid  border-1"
                            : " border border-0 " + props.class
                            }`}
                        required={props.required}
                        itemTemplate={ItemTemplate} 
                    ></Auto>
                    {props.icon && (
                        <button
                            className="btn btn-primary border-0 p-0 px-2"
                            type="button"
                            disabled={!props.iconClicked}
                            onClick={() => {
                                props.iconClicked?.(value);
                            }}
                        >
                            <i className={` iconssc-${props.icon}`} />
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}